import React from "react";
import PropTypes from "prop-types";
import { Form, Select, Row, Col } from "antd";
import {
  GrantSectionHeading,
  TableLabel,
  HideArrow,
  WrapLabel,
  LabelWrapper,
  InputWrapper,
  ErrorMsgWrap,
  Para,
  GrantDropdown,
  SelectOptionWrapper,
  CheckboxLabel,
  SelectDropdown,
  InputSection
} from "../../style";
import TextBoxComponent from "../TextBoxComponent/TextBoxComponent";
import { AddButtonContainer } from "./style";
import Preloader from "../../../../../../CommonComponents/Preloader/Preloader";
import FormBase from "../../../../../../CommonComponents/FormBase/FormBase";
import purposeInputConfig from "./inputConfig";
import {
  CustomCheckbox,
  DisplayFlex,
} from "../../../../../../CommonComponents/commonStyles";
import regexMap from "../../../../../../utils/regexMap";
import plus from "../../../../../../assets/icons/plus-icon.svg";
import {
  addPurpose,
  projectName,
  addEventName,
  addMissionaryName,
  addMissionaryLocation,
} from "../../actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Contents from "../../../../../../CommonComponents/ContentMessages";
import { recordError } from "../../../../../../utils/commonUtil";
import { CapsuleButton } from "../../../../../../CommonComponents/Commons/commonComponents";

import { grantPurposeDerivedStates } from '../../Selectors/GrantPurposeSelectors';

export class GrantPurposeForm extends FormBase {
  constructor(props) {
    super(props);
    const selectedOpt = this.filterDatabyGrantId(
      props.grantPurposeId,
      props.grantPurposeData
    );
    this.state = {
      purpose: {
        value: props.grantPurposeId || "",
        touched: false,
        valid: "",
        validationRules: {
          isRequired: true,
        },
        messages: {
          isRequired: "Please select a purpose to continue.",
        },
      },
      addtnlComments: {
        visible: false,
        touched: false,
        value: "",
        valid: "",
        validationRules: {
          maxLength: 300,
          shouldNotMatchPattern: regexMap.eliminateSpecialCharacter,
        },
        messages: {
          maxLength: "Please enter less than 300 characters",
          shouldNotMatchPattern: `The following special characters are not allowed : |, <, >.`,
        },
      },
      showCommentsBtn: false,
      purposeInput1: {},
      purposeInput2: {},
      purposeCheck: {},
      standardLanguage: selectedOpt ? selectedOpt.standardLanguage : "",
      purposeName: props.selectedPurposeName || "",
      ...this.getSelectedPurposeInputState(selectedOpt, props),
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.checkFormValid = this.checkFormValid.bind(this);
    this.runFormValidation = this.runFormValidation.bind(this);
  }
  handleInputChangeFirst(e) {
    if (this.props.purpose === "Specific project") {
      // Set Project Name, Event Name, Missionary Name
      this.props.projectName(e.target.value);
    } else if (this.props.purpose === "Underwriting cost of event") {
      this.props.addEventName(e.target.value);
    } else if (this.props.purpose === "Missionary support") {
      this.props.addMissionaryName(e.target.value);
    }
    this.handleInputChange(e);
  }
  handleInputChangeSecond(e) {
    if (this.props.purpose === "Missionary support") {
      this.props.addMissionaryLocation(e.target.value);
    }
    this.handleInputChange(e);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.individualValidator !== this.props.individualValidator) {
      this.runFormValidation();
    }
    // isloading is false and not equal to previous
    if (!this.props.isLoading && this.props.isLoading !== prevProps.isLoading) {
      const selectedOpt = this.filterDatabyGrantId(
        this.props.grantPurposeId,
        this.props.grantPurposeData
      );
      this.setState(
        {
          ...this.getSelectedPurposeInputState(selectedOpt, this.props),
        },
        this.handleFormChange
      );
    }
  }

  getSelectedPurposeInputState = (selectedOpt, props = {}) => {
    if (selectedOpt) {
      const selectedOptInputConfig = this.filterDatabyGrantName(
        selectedOpt.purpose,
        purposeInputConfig
      );
      return {
        standardLanguage: selectedOpt.standardLanguage,
        purposeName: selectedOpt.purpose,
        addtnlComments: selectedOpt.commentsAllowed
          ? this.formCommentsState(
              selectedOpt.commentsRequired,
              props.addtnlComments
            )
          : {},
        showCommentsBtn: !props.addtnlComments && selectedOpt.commentsAllowed,
        purposeInput1:
          selectedOptInputConfig && selectedOptInputConfig.input1.required
            ? this.formDynamicInputState(
                selectedOptInputConfig,
                "input1",
                150,
                props
              )
            : {},
        purposeInput2:
          selectedOptInputConfig && selectedOptInputConfig.input2.required
            ? this.formDynamicInputState(
                selectedOptInputConfig,
                "input2",
                200,
                props
              )
            : {},
        purposeCheck:
          selectedOpt &&
          selectedOpt.certificationRequired &&
          !this.props.isPurposeCheckNotShow
            ? this.formPurposeCheckState(
                selectedOpt.certificationContent,
                props.purposeCertification
              )
            : {},
      };
    }
    return {};
  };

  showAdditonalComments = () => {
    try {
      this.setState((prevState) => ({
        addtnlComments: { ...prevState.addtnlComments, visible: true },
        showCommentsBtn: false,
      }));
    } catch (error) {
      recordError(error);
    }
  };

  formPurposeCheckState = (content, checked) => ({
    visible: true,
    value: checked || false,
    valid: "",
    touched: false,
    content,
    validationRules: {
      isRequired: true,
    },
    messages: {
      isRequired: "Please check the box to proceed.",
    },
  });

  // props or any object can be passed, to preload values into the input boxes
  formDynamicInputState = (config, inputName, maxLength, props = {}) => {
    const inputKey = config ? config[inputName].key : "";
    return {
      visible: config ? config[inputName].required : false,
      label: config ? config[inputName].label : "",
      value: inputKey ? props[inputKey] : "",
      valid: "",
      key: inputKey,
      validationRules: {
        maxLength,
        isRequired: config && config[inputName].required,
        shouldNotMatchPattern: regexMap.eliminateSpecialCharacter,
      },
      messages: {
        maxLength: `Please enter less than ${maxLength} characters`,
        isRequired: `Please enter ${config[
          inputName
        ].label.toLowerCase()} to continue`,
        shouldNotMatchPattern: `The following special characters are not allowed : |, <, >.`,
      },
    };
  };

  formCommentsState = (isRequired, comments) => ({
    visible: !!comments,
    value: comments || "",
    valid: "",
    touched: false,
    validationRules: {
      maxLength: 300,
      isRequired: isRequired,
      shouldNotMatchPattern: regexMap.eliminateSpecialCharacter,
    },
    messages: {
      maxLength: "Please enter less than 300 characters",
      isRequired: `Please enter additional comments to continue`,
      shouldNotMatchPattern: `The following special characters are not allowed : |, <, >.`,
    },
  });

  filterDatabyGrantId = (id, options) => {
    const selectedOption = options.filter((option) => {
      return option.grantPurposeId === id;
    });
    return selectedOption[0];
  };

  filterDatabyGrantName = (name, options) => {
    const selectedOption = options.filter((option) => {
      return option.purposeName === name;
    });
    return selectedOption[0];
  };

  onChangeHandler = (value) => {
    const selectedOptionVal = this.filterDatabyGrantId(
      value,
      this.props.grantPurposeData
    );
    this.setState(
      (prevState) => ({
        purpose: {
          ...prevState.purpose,
          touched: true,
          value,
          valid: "",
        },
        ...this.getSelectedPurposeInputState(selectedOptionVal),
      }),
      this.handleFormChange
    );
    this.props.addPurpose(selectedOptionVal.purpose);
    // Reset Project Name, Event Name, Missionary Name and Missionary Location.
    this.props.projectName("");
    this.props.addEventName("");
    this.props.addMissionaryName("");
    this.props.addMissionaryLocation("");
  };

  formatData = () => {
    let input1Val = {};
    let input2Val = {};
    if (this.state.purposeInput1.value) {
      input1Val = {
        [this.state.purposeInput1.key]: this.state.purposeInput1.value,
      };
    }
    if (this.state.purposeInput2.value) {
      input2Val = {
        [this.state.purposeInput2.key]: this.state.purposeInput2.value,
      };
    }
    return {
      data: {
        ...input1Val,
        ...input2Val,
        purposeId: this.state.purpose.value,
        purposeName: this.state.purposeName,
        additionalComments: this.state.addtnlComments.value || "",
        purposeCertification: this.state.purposeCheck.value || false,
        standardLanguage: this.state.standardLanguage || "",
      },
      isFormValid: this.checkFormValid(this.state),
    };
  };

  renderAddCommentButton = () => (
    <div className="mt1">
      <CapsuleButton 
        id="btnAddAdditionalComments" 
        onClick={this.showAdditonalComments}
        text="Add Additional Comments"
        iconType="add"
        alt = "add icon"
      />
    </div>
  );

  purposeInputsVisible = (addtnlComments, purposeInput1, purposeInput2) => {
    return (
      (addtnlComments && addtnlComments.visible) ||
      (purposeInput1 && purposeInput1.visible) ||
      (purposeInput2 && purposeInput2.visible)
    );
  };

  // Fixes bug 6056 - show grant purpose from the value returned from api
  // there can be instances where an earlier selected purpose might be disabled
  // and not returned in /getAllGrantPurposes
  createDropdownDefault = (purpose) => {
    const { grantPurposeId, selectedPurposeName } = this.props;
    if (grantPurposeId && !purpose.touched) {
      return <SelectOptionWrapper>{selectedPurposeName}</SelectOptionWrapper>;
    }
    return purpose.value ? (
      purpose.value
    ) : (
      <SelectDropdown>Select a purpose</SelectDropdown>
    );
  };

  render() {
    const {
      grantPurposeData,
      isLoading,
      grantAgreementFlag = false,
    } = this.props;
    const {
      addtnlComments,
      purposeInput1,
      purposeInput2,
      showCommentsBtn,
      purposeCheck,
      purpose,
    } = this.state;
    let purposeContent;
    if (purposeCheck.content) {
      purposeContent = purposeCheck.content.replace(/##/g, "<br />");
    }
    return (
      <div>
        <Form hideRequiredMark>
          <Row className="mb-30">
            <Col lg={{ span: 24 }}>
              <GrantSectionHeading>Grant Purpose</GrantSectionHeading>
              <TableLabel>
                {this.props.purposeText
                  ? this.props.purposeText
                  : "Select the purpose of this grant recommendation."}
              </TableLabel>
            </Col>
          </Row>
          {isLoading ? (
            <Preloader />
          ) : (
            <>
              <Row className="purpose">
                <HideArrow>
                  <WrapLabel>
                    <Form.Item
                      className="mb0"
                      colon={false}
                      label={<LabelWrapper>Purpose of grant</LabelWrapper>}
                    >
                      <Col lg={8}>
                        <InputWrapper>
                          <div
                            id="grantPurposeDropdown"
                            style={{ position: "relative" }}
                          >
                            <GrantDropdown
                              id="selGrantPurpose"
                              aria-label="purpose-select"
                              onChange={this.onChangeHandler}
                              value={this.createDropdownDefault(purpose)}
                              role={false}
                            >
                              {grantPurposeData.map((optionData) => (
                                <Select.Option
                                  value={optionData.grantPurposeId}
                                  key={optionData.grantPurposeId}
                                >
                                  <SelectOptionWrapper>
                                    {optionData.purpose}
                                  </SelectOptionWrapper>
                                </Select.Option>
                              ))}
                            </GrantDropdown>
                          </div>
                        </InputWrapper>
                        {purpose.valid && (
                          <ErrorMsgWrap>
                            {purpose.messages[purpose.valid]}
                          </ErrorMsgWrap>
                        )}
                      </Col>
                      {showCommentsBtn && (
                        <Col lg={{ span: 6, offset: 1 }} md={18}>
                          <AddButtonContainer>
                            {this.renderAddCommentButton()}
                          </AddButtonContainer>
                          {addtnlComments.valid && (
                            <ErrorMsgWrap center>
                              {addtnlComments.messages[addtnlComments.valid]}
                            </ErrorMsgWrap>
                          )}
                        </Col>
                      )}
                    </Form.Item>
                  </WrapLabel>
                </HideArrow>
              </Row>
              <Row
                className={
                  this.purposeInputsVisible(
                    addtnlComments,
                    purposeInput1,
                    purposeInput2
                  )
                    ? "mt-40"
                    : ""
                }
              >
                {addtnlComments.visible && (
                  <Row>
                    <Col lg={16}>
                      <TextBoxComponent
                        labelText={`Additional information for the charity`}
                        isRequired="true"
                        maxLength={300}
                        name="addtnlComments"
                        label="additional-comment"
                        value={addtnlComments.value}
                        inputChange={this.handleInputChange}
                        onBlur={this.handleBlur}
                        grantAgreementFlag
                      />
                      {addtnlComments.valid && (
                        <ErrorMsgWrap>
                          {addtnlComments.messages[addtnlComments.valid]}
                        </ErrorMsgWrap>
                      )}
                    </Col>
                  </Row>
                )}
                {purposeInput1 && purposeInput1.visible && (
                  <Row>
                    <Col lg={8}>
                      <WrapLabel>
                        <Form.Item
                          colon={false}
                          label={
                            <LabelWrapper>{purposeInput1.label}</LabelWrapper>
                          }
                        >
                          <InputWrapper>
                            <InputSection
                              name="purposeInput1"
                              maxLength={150}
                              onChange={(e) => {
                                this.handleInputChangeFirst(e);
                              }}
                              value={purposeInput1.value}
                              onBlur={this.handleBlur}
                            />
                            {purposeInput1.valid && (
                              <ErrorMsgWrap>
                                {purposeInput1.messages[purposeInput1.valid]}
                              </ErrorMsgWrap>
                            )}
                          </InputWrapper>
                        </Form.Item>
                      </WrapLabel>
                    </Col>
                  </Row>
                )}
                {purposeInput2 && purposeInput2.visible && (
                  <Row>
                    <Col lg={8}>
                      <WrapLabel>
                        <Form.Item
                          colon={false}
                          label={
                            <LabelWrapper>{purposeInput2.label}</LabelWrapper>
                          }
                        >
                          <InputWrapper>
                            <InputSection
                              name="purposeInput2"
                              maxLength={200}
                              onChange={(e) => {
                                this.handleInputChangeSecond(e);
                              }}
                              value={purposeInput2.value}
                              onBlur={this.handleBlur}
                            />
                            {purposeInput2.valid && (
                              <ErrorMsgWrap>
                                {purposeInput2.messages[purposeInput2.valid]}
                              </ErrorMsgWrap>
                            )}
                          </InputWrapper>
                        </Form.Item>
                      </WrapLabel>
                    </Col>
                  </Row>
                )}
              </Row>
              {purposeCheck && purposeCheck.visible && (
                <Row className={grantAgreementFlag ? "mt-30" : "mt-20"}>
                  <Col lg={17}>
                    <WrapLabel>
                      {purposeContent && (
                        <Para
                          dangerouslySetInnerHTML={{ __html: purposeContent }}
                        ></Para>
                      )}
                      <Row className="mb0">
                        <DisplayFlex>
                          <CustomCheckbox
                            id="chkPurposeCheck"
                            name="purposeCheck"
                            aria-label="purpose"
                            checked={purposeCheck.value}
                            onChange={this.handleCheckboxChange}
                          ></CustomCheckbox>
                          <CheckboxLabel>
                            <Contents.Consumer>
                              {(props) => {
                                if (
                                  props.page_checkbox &&
                                  props.page_checkbox["Recommend a Grant"]
                                ) {
                                  const extractedData = props.page_checkbox[
                                    "Recommend a Grant"
                                  ].filter(
                                    (item) =>
                                      item.name === "Purpose Checkbox"
                                  );
                                  return extractedData.map((data) => {
                                    return (
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: data.field_checkbox_conent,
                                        }}
                                      ></span>
                                    );
                                  });
                                }
                              }}
                            </Contents.Consumer>
                          </CheckboxLabel>
                        </DisplayFlex>
                      </Row>
                      {purposeCheck.valid && (
                        <ErrorMsgWrap>
                          {purposeCheck.messages[purposeCheck.valid]}
                        </ErrorMsgWrap>
                      )}
                    </WrapLabel>
                  </Col>
                </Row>
              )}
            </>
          )}
        </Form>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  ...grantPurposeDerivedStates(state.toJS()),
});

export const mapDispatchToProps = (dispatch) => ({
  addPurpose: (data) => dispatch(addPurpose(data)),
  projectName: (data) => dispatch(projectName(data)),
  addEventName: (data) => dispatch(addEventName(data)),
  addMissionaryName: (data) => dispatch(addMissionaryName(data)),
  addMissionaryLocation: (data) => dispatch(addMissionaryLocation(data)),
});

GrantPurposeForm.propTypes = {
  addtnlComments: PropTypes.string,
  eventName: PropTypes.string,
  grantPurposeData: PropTypes.arrayOf(
    PropTypes.shape({
      certificationContent: PropTypes.any,
      certificationRequired: PropTypes.bool,
      commentsAllowed: PropTypes.bool,
      commentsLabelName: PropTypes.string,
      commentsRequired: PropTypes.bool,
      deprecatedGpId: PropTypes.any,
      description: PropTypes.string,
      descriptiveContent: PropTypes.any,
      displayOrder: PropTypes.any,
      fastPassEligible: PropTypes.bool,
      grantPurposeId: PropTypes.number,
      purpose: PropTypes.string,
      showInDropDown: PropTypes.bool,
      standardLanguage: PropTypes.any,
    })
  ),
  grantPurposeId: PropTypes.string,
  handleFormChange: PropTypes.func,
  individualValidator: PropTypes.bool,
  isLoading: PropTypes.bool,
  missionaryLocation: PropTypes.string,
  missionaryName: PropTypes.string,
  projectName: PropTypes.string,
  purposeCertification: PropTypes.bool,
  selectedPurposeName: PropTypes.string,
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GrantPurposeForm)
);
